import type { DeepWritable, UUID } from '@cmg/common';
import { getDataSource } from '@cmg/data-grid';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import type { InvestorFirmFragment } from '../../../graphql/__generated__';
import { useInvestorFirmsQuery } from './useInvestorFirmsQuery';

export function useInvestorFirmsGridDataSource() {
  const { crmIntegrationId } = useParams<{ crmIntegrationId?: UUID }>();

  const loadRows = useInvestorFirmsQuery(crmIntegrationId);

  return useMemo(() => {
    return getDataSource({
      getData: async variables => {
        const { data, error } = await loadRows(variables);
        if (error) {
          throw error;
        }
        return {
          rowData: (data?.investorFirmsGrid?.items ?? []) as DeepWritable<InvestorFirmFragment[]>,
          rowCount: data?.investorFirmsGrid?.totalCount ?? 0,
        };
      },
    });
  }, [loadRows]);
}
